module.exports = __webpack_public_path__ + "static/media/hans-age-gate-background.5169e3e3.jpg";